export default __webpack_public_path__ + "static/media/privilege-ticket-yellow.dff9bccd.svg";